import { render } from "./ProjectEditModal.vue?vue&type=template&id=072503cc"
import script from "./ProjectEditModal.vue?vue&type=script&lang=js"
export * from "./ProjectEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__